import { Button, ButtonProps } from '@/libraries/ui'
import { useShowAlert } from '@/libraries/ui/hooks'
import { useT } from '@/i18n'

interface DeleteButtonProps extends ButtonProps {
  text: string
  iconOnly?: boolean
  disabled?: boolean
  onDelete: () => unknown
  confirmText: React.ReactNode
  confirmTitle?: string
  minimal?: boolean
}

export function DeleteButton({ onDelete, text, confirmTitle, confirmText, ...props }: DeleteButtonProps) {
  const t = useT('components.deleteButton')
  const showAlert = useShowAlert()

  return <Button
    {...props}
    icon="trash"
    text={text}
    color="danger"
    onClick={() => showAlert({
      title: confirmTitle ?? text,
      buttons: [
        {
          text: t('delete'),
          color: 'danger',
          action: onDelete,
        },
        t('cancel'),
      ],
      children: confirmText,
    })}
  />
}
